import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import './SearchCarsSection.css';
import { useNavigate } from 'react-router-dom';
import HomeSearchbar from "../Components/HomeSearchbar";
import Formbg from "./assets/form-bg.jpg";

const SearchCarsSection = () => {
    const [makers, setMakers] = useState([]);
    const [selectedMaker, setSelectedMaker] = useState('');
    const [models, setModels] = useState([]);
    const [selectedModel, setSelectedModel] = useState('');
    const [years, setYears] = useState([]); // For year dropdown options
    const [selectedYearFrom, setSelectedYearFrom] = useState('');
    const [selectedYearTo, setSelectedYearTo] = useState('');
    const [prices, setPrices] = useState([]); // For price dropdown options
    const [selectedPriceFrom, setSelectedPriceFrom] = useState('');
    const [selectedPriceTo, setSelectedPriceTo] = useState('');
    const [vins, setVins] = useState([]); // For VIN dropdown
    const [selectedVin, setSelectedVin] = useState('');
    const [mileages, setMileages] = useState([]); // For Mileage dropdown
    const [selectedMileage, setSelectedMileage] = useState('');
    const [fuels, setFuels] = useState([]); // For Fuel dropdown
    const [selectedFuel, setSelectedFuel] = useState('');
    const [transmissions, setTransmissions] = useState([]); // For Transmission dropdown
    const [selectedTransmission, setSelectedTransmission] = useState('');
    const [bodyTypes, setBodyTypes] = useState([]); // For Body Type dropdown
    const [selectedBodyType, setSelectedBodyType] = useState('');
    const [colors, setColors] = useState([]); // For Color dropdown
    const [selectedColor, setSelectedColor] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        // Fetch makers
        fetch('https://api.mitradingjp.com/getDropdownOptions.php')
            .then(response => response.json())
            .then(data => setMakers(data))
            .catch(error => console.error('Error fetching makers:', error));

        // Fetch years for the "Year From" and "Year To" dropdowns
        fetch('https://api.mitradingjp.com/getYears.php')
            .then(response => response.json())
            .then(data => setYears(data))
            .catch(error => console.error('Error fetching years:', error));

        // Fetch prices for the "Price From" and "Price To" dropdowns
        fetch('https://api.mitradingjp.com/getPrices.php')
            .then(response => response.json())
            .then(data => setPrices(data))
            .catch(error => console.error('Error fetching prices:', error));

        // Fetch VINs
        fetch('https://api.mitradingjp.com/getVins.php')
            .then(response => response.json())
            .then(data => setVins(data))
            .catch(error => console.error('Error fetching VINs:', error));

        // Fetch Mileages
        fetch('https://api.mitradingjp.com/getMileages.php')
            .then(response => response.json())
            .then(data => setMileages(data))
            .catch(error => console.error('Error fetching mileages:', error));

        // Fetch Fuels
        fetch('https://api.mitradingjp.com/getFuels.php')
            .then(response => response.json())
            .then(data => setFuels(data))
            .catch(error => console.error('Error fetching fuels:', error));

        // Fetch Transmissions
        fetch('https://api.mitradingjp.com/getTransmissions.php')
            .then(response => response.json())
            .then(data => setTransmissions(data))
            .catch(error => console.error('Error fetching transmissions:', error));

        // Fetch Body Types
        fetch('https://api.mitradingjp.com/getBodyTypes.php')
            .then(response => response.json())
            .then(data => setBodyTypes(data))
            .catch(error => console.error('Error fetching body types:', error));

        // Fetch Colors
        fetch('https://api.mitradingjp.com/getColors.php')
            .then(response => response.json())
            .then(data => setColors(data))
            .catch(error => console.error('Error fetching colors:', error));
    }, []);

    const handleMakerChange = (event) => {
        const maker = event.target.value;
        setSelectedMaker(maker);
        setSelectedModel(''); // Reset model when maker changes
        fetch(`https://api.mitradingjp.com/getModels.php?maker=${maker}`)
            .then(response => response.json())
            .then(data => setModels(data))
            .catch(error => console.error('Error fetching models:', error));
    };

    const handleModelChange = (event) => {
        setSelectedModel(event.target.value);
    };

    const handleYearFromChange = (event) => {
        setSelectedYearFrom(event.target.value);
    };

    const handleYearToChange = (event) => {
        setSelectedYearTo(event.target.value);
    };

    const handlePriceFromChange = (event) => {
        setSelectedPriceFrom(event.target.value);
    };

    const handlePriceToChange = (event) => {
        setSelectedPriceTo(event.target.value);
    };

    const handleVinChange = (event) => {
        setSelectedVin(event.target.value);
    };

    const handleMileageChange = (event) => {
        setSelectedMileage(event.target.value);
    };

    const handleFuelChange = (event) => {
        setSelectedFuel(event.target.value);
    };

    const handleTransmissionChange = (event) => {
        setSelectedTransmission(event.target.value);
    };

    const handleBodyTypeChange = (event) => {
        setSelectedBodyType(event.target.value);
    };

    const handleColorChange = (event) => {
        setSelectedColor(event.target.value);
    };

    const handleSearch = (event) => {
        event.preventDefault();
        navigate('/search-result', {
            state: {
                maker: selectedMaker,
                model: selectedModel,
                yearFrom: selectedYearFrom,
                yearTo: selectedYearTo,
                priceFrom: selectedPriceFrom,
                priceTo: selectedPriceTo,
                vin: selectedVin,
                mileage: selectedMileage,
                fuel: selectedFuel,
                transmission: selectedTransmission,
                bodyType: selectedBodyType,
                color: selectedColor,
            },
        });
    };

    return (
        <section className="container-fluid">
            <div className="col-12">
                <div className="serchmainbox">
                   <h2>Find Your Next Car</h2>
                   <p>Welcome to M.I Trading Japan Marketplace, where you can reserach, locate and buy your next Car or Truck</p>
                    <form onSubmit={handleSearch}>
                        <div className="row my-5">
                            <div className="col-lg-1 col-md-3 col-12"></div>
                            {/* Maker Dropdown */}
                            <div className="col-lg-3 col-md-3 col-12">
                                <label htmlFor="make" className="form-label text-black">Select Maker</label>
                                <select id="make" className="form-select" onChange={handleMakerChange}>
                                    <option value="">Select</option>
                                    {makers.map((maker, index) => (
                                        <option key={index} value={maker}>{maker}</option>
                                    ))}
                                </select>
                            </div>

                            {/* Model Dropdown */}
                            <div className="col-lg-3 col-md-3 col-12">
                                <label htmlFor="model" className="form-label text-black">Select Model</label>
                                <select id="model" className="form-select" onChange={handleModelChange}>
                                    <option value="">Select</option>
                                    {models.map((model, index) => (
                                        <option key={index} value={model}>{model}</option>
                                    ))}
                                </select>
                            </div>

                            {/* Year From Dropdown */}
                            <div className="col-lg-3 col-md-3 col-12">
                                <label htmlFor="yearFrom" className="form-label text-black">Select Year</label>
                                <select id="yearFrom" className="form-select" onChange={handleYearFromChange}>
                                    <option value="">Select</option>
                                    {years.map((year, index) => (
                                        <option key={index} value={year}>{year}</option>
                                    ))}
                                </select>
                            </div>

                            {/* Search Button */}
                            <div className="col-lg-1 col-md-3 col-12">
                                <div className="mt-4 text-end">
                                    <button type="submit" className="btn btn-lg btn-primary">
                                        GO
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>

                     <div className="row mb-5">
                        <HomeSearchbar />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SearchCarsSection;